module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Res.":"Рез."}}')
  delete Component.options._Ctor
}
